import { useMutation, useQuery } from '@tanstack/react-query'

import type { UseMutationResult, UseQueryResult } from '@tanstack/react-query'
import type { ICreateTodolistTemplatePayload } from '~/api/todolists'
import type { ITodolistTemplate } from '~/types/todolist-template'

import {
  createTodolistTemplate,
  getTodolistTemplate,
  getTodolistTemplates,
  updateTodolistTemplate,
} from '~/api/todolists'

////////// KEYS //////////

export const keys = {
  all: ['todolist-templates'] as const,
  details: (templateId: string) => [...keys.all, 'details', templateId] as const,
  list: () => [...keys.all, 'list'] as const,
}

////////// QUERIES //////////

export const useTodolistTemplatesQuery = (): UseQueryResult<ITodolistTemplate[], unknown> => {
  return useQuery({
    queryFn: getTodolistTemplates,
    queryKey: keys.list(),
  })
}

export const useTodolistTemplateQuery = (templateId: string): UseQueryResult<ITodolistTemplate, unknown> => {
  return useQuery({
    queryFn: () => getTodolistTemplate(templateId),
    queryKey: keys.details(templateId),
  })
}

//////// MUTATIONS //////////

export const useCreateTodolistTemplateMutation = (): UseMutationResult<
  ITodolistTemplate,
  unknown,
  ICreateTodolistTemplatePayload
> => {
  return useMutation({ mutationFn: createTodolistTemplate })
}

export const useUpdateTodolistTemplateMutation = (): UseMutationResult<
  ITodolistTemplate,
  unknown,
  { data: ICreateTodolistTemplatePayload; templateId: string }
> => {
  return useMutation({ mutationFn: updateTodolistTemplate })
}
